const DEFAULT_HEADER_PROPS = {
  backButtonAriaLabel: "back",
  closeButtonAriaLabel: "Close Drawer"
};
const DRAWER_WIDTH = "350px";
export {
  DEFAULT_HEADER_PROPS,
  DRAWER_WIDTH
};
